<div class="inline-flex flex-col gap-4 min-w-40 h-full p-3 justify-between bg-white border border-neutral-200 rounded ">
  <div class="flex flex-col gap-1">
    <p class="m-0 text-brand-bright-orange text-xs font-semibold leading-none ">
      {{ groupTitle }}
    </p>
    <p class="mb-0 leading-none">
      {{title}}
    </p>
  </div>

  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-col">
      <h3 class="m-0 text-lg font-semibold leading-none whitespace-nowrap">{{firstValue || 0 | numberFormat}}</h3>
      <div class="flex h-4 items-end" *ngIf="firstSubTitle">
        <p class="mb-0 text-sm text-gray-800 leading-none">
          {{firstSubTitle}}
        </p>
      </div>
    </div>
    <div class="flex flex-col">
      <h3 class="m-0 text-lg font-semibold leading-none whitespace-nowrap">{{secondValue || 0 | numberFormat}}</h3>
      <div class="flex h-4 items-end" *ngIf="secondSubTitle">
        <p class="mb-0 text-sm text-gray-800 leading-none">
          {{secondSubTitle}}
        </p>
      </div>
    </div>
  </div>
</div>
